// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":root{--strong-text-color:var(--color-text-strong)}.h-wysiwyg-content{word-break:break-all}[lang=en] .h-wysiwyg-content{word-break:break-word}.h-card .h-wysiwyg-content p,.h-wysiwyg-content p{margin:0}.h-wysiwyg-content p:empty{height:1em}.h-wysiwyg-content ol ol,.h-wysiwyg-content ol ul,.h-wysiwyg-content ul ol,.h-wysiwyg-content ul ul{margin:0}", ""]);
// Exports
module.exports = exports;
